import React from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';

import LinkedAccountDialog from '../LinkedAccountsDialog';
import PasswordField from '../PasswordField';
import StaticEmailField from '../StaticEmailField';

import { formValidate } from '@eb/eds-utils';

import { logInValidate as validate } from '../utils';
import { setWindowLocation } from '@eb/http';
import { BASE_URL, LINK_ACCOUNTS_LOG_IN_FORM } from '../../constants';

import { EVENTBRITE_PROVIDER } from '../../constants/newIndex';

import CaptchaField from '../CaptchaField';
import ForgotPasswordLink from '../ForgotPasswordLink';
import FormSubmitButton from '../FormSubmitButton';

import './LoginForm.scss';

class LinkAccountsLoginForm extends React.Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        email: PropTypes.string,
        handleEmailEdit: PropTypes.func,
        buttonCTA: translationPropType,
        handleForgotPassword: PropTypes.func,
        handleClickViewPassword: PropTypes.func,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
        linkedAccountSuccessUrl: PropTypes.string,
        showCaptcha: PropTypes.bool,
        recaptcha2PublicKey: PropTypes.string,
        sourceProvider: PropTypes.string,
        /* Props Provided Via ReduxForm */
        submitFailed: PropTypes.bool,
        submitSucceeded: PropTypes.bool,
        submitting: PropTypes.bool,
        onForceStld: PropTypes.func,
    };

    state = {
        showDialog: false,
    };

    constructor(props) {
        super(props);

        this.dialogTimeout = null;
    }

    componentDidMount() {
        const { onForceStld } = this.props;

        if (onForceStld) {
            onForceStld();
        }
    }

    componentWillReceiveProps({ submitting, submitFailed, error }) {
        const {
            showNotification,
            clearNotification,
            linkedAccountSuccessUrl,
        } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }

        if (linkedAccountSuccessUrl) {
            this.setState({
                showDialog: true,
            });
            this.dialogTimeout = setTimeout(
                () => this._handleCloseDialog(),
                5000,
            );
        }
    }

    componentWillUnmount() {
        const { clearNotification } = this.props;

        clearNotification();
        if (this.dialogTimeout) {
            clearTimeout(this.dialogTimeout);
            this.dialogTimeout = null;
        }
    }

    _handleForgotPassword = () => {
        const {
            handleForgotPassword,
            clearNotification,
            sourceProvider,
        } = this.props;

        const mustLinkAccount = true;

        clearNotification();
        // Send must_link_account param as true, so we can link it after the resetting the password
        handleForgotPassword({
            sourceProvider,
            mustLinkAccount,
        });
    };

    _handleCloseDialog = () => {
        const { linkedAccountSuccessUrl } = this.props;
        const redirectUrl = linkedAccountSuccessUrl
            ? linkedAccountSuccessUrl
            : BASE_URL;

        // If user triggered redirect manually, discard auto-redirect
        if (this.dialogTimeout) {
            clearTimeout(this.dialogTimeout);
        }

        this.setState({
            showDialog: false,
        });

        setWindowLocation(redirectUrl);
    };

    //When user clicks on view password
    _handleOnIconClick = () => {
        const { handleClickViewPassword } = this.props;
        if (handleClickViewPassword) {
            handleClickViewPassword();
        }
    };

    render() {
        const {
            handleSubmit,
            email,
            handleEmailEdit,
            submitting,
            submitSucceeded,
            buttonCTA,
            clearNotification,
            clearAuthNotification,
            submitFailed,
            showCaptcha,
            recaptcha2PublicKey,
        } = this.props;

        const isSubmitDisabled = submitting || submitSucceeded;

        const _handleClearNotification = () => {
            clearNotification && clearNotification();
            clearAuthNotification && clearAuthNotification();
        };

        return (
            <div className="eds-fx--fade-in eds-fx--delay-2">
                <LinkedAccountDialog
                    showDialog={this.state.showDialog}
                    onCloseDialog={this._handleCloseDialog}
                />
                <form onSubmit={handleSubmit} noValidate="novalidate">
                    <StaticEmailField
                        email={email}
                        clearNotification={_handleClearNotification}
                    />
                    <PasswordField
                        isLogin={true}
                        submitFailed={submitFailed}
                        onIconClick={this._handleOnIconClick}
                    />
                    <CaptchaField
                        showCaptcha={showCaptcha}
                        recaptcha2PublicKey={recaptcha2PublicKey}
                        submitFailed={submitFailed}
                    />

                    <div className="login-form__actions eds-l-pad-top-4">
                        <ForgotPasswordLink
                            handleForgotPassword={this._handleForgotPassword}
                            dataAutomation="link-and-login-forgot-password"
                        />

                        <FormSubmitButton
                            submitDisabled={isSubmitDisabled}
                            style="neutral"
                            dataAutomation="link-and-login-submit-button"
                            buttonCTA={buttonCTA}
                        />
                    </div>
                </form>
            </div>
        );
    }
}

export default formValidate({
    validate,
    form: LINK_ACCOUNTS_LOG_IN_FORM,
    touchOnBlur: false,
})(LinkAccountsLoginForm);
